import React from 'react';

const EventFilter = ({events, changeEventFilter}) => (
  <div>
    <ul className="nav nav-tabs" role="tablist">
      <Filter
        currentFilter={events.filter}
        filterName="upcoming"
        changeEventFilter={changeEventFilter}
      >
        Upcoming ({events.upcomingEventsList.length})
      </Filter>

      <Filter
        currentFilter={events.filter}
        filterName="all"
        changeEventFilter={changeEventFilter}
      >
        All ({events.eventsList.length})
      </Filter>
    </ul>
  </div>
);

const Filter = ({currentFilter, filterName, changeEventFilter, children}) => (
  <li role="presentation" className={currentFilter === filterName ? 'active' : ''}>
    <a aria-controls={filterName} role="tab" data-toggle="tab" onClick={() => changeEventFilter(filterName)}>
      {children}
    </a>
  </li>
);

export default EventFilter;



// WEBPACK FOOTER //
// ./src/components/Events/EventFilter.js